import { BASE_URL } from "./apiConst";

export const PREVIOUS_YEAR_DUE_FEES = `${BASE_URL}/student/portal/fee`;

export const HOSTEL_FEES = `${BASE_URL}/fee/hostelfees`;
